// removed by extract-text-webpack-plugin
module.exports = {"htmlellipsis_wrap":"index_2SQ6D9B","htmlellipsis_wrap_vip":"index_1y75gmq index_2SQ6D9B"};


//////////////////
// WEBPACK FOOTER
// ./src/component/book/index.css
// module id = 785
// module chunks = 0